import React from "react";
import { createRoot } from "react-dom/client";

import MainComponent from "./views/MainComponent";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<MainComponent />);

